import { motion } from "framer-motion";
import { ArrowRight, Zap, Timer } from "lucide-react";
import { PRODUCT_ITEMS } from "@/lib/salesData";

/* CtaFinalSection — CTA final com urgência, timer e preço */
export function CtaFinalSection() {
  return (
    <section className="py-16 sm:py-24 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent/10 via-transparent to-transparent pointer-events-none" />

      <div className="container max-w-3xl mx-auto px-4 relative z-10 text-center">

        {/* Badge de urgência animado */}
        <motion.div
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ repeat: Infinity, duration: 2.5 }}
          className="inline-flex items-center gap-2 bg-destructive/10 border border-destructive/30 text-destructive text-xs sm:text-sm font-bold px-4 sm:px-5 py-2 rounded-full mb-5 sm:mb-6"
        >
          <Zap className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
          Oferta especial por tempo limitado
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4"
        >
          Comece hoje mesmo.
          <br />
          <span className="text-accent">Seu plantão não pode esperar.</span>
        </motion.h2>

        <p className="text-muted-foreground text-sm sm:text-base mb-6 sm:mb-8 max-w-xl mx-auto">
          Acesso imediato, conteúdo validado clinicamente e garantia de 7 dias.
          Invista no seu desenvolvimento agora — de forma segura.
        </p>

        {/* Preço */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="bg-card border border-border rounded-2xl p-5 sm:p-6 mb-6 sm:mb-8 inline-block w-full sm:w-auto"
        >
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 flex-wrap">
            <div className="text-center sm:text-left">
              <span className="text-muted-foreground text-sm line-through block">De R$ 97,00</span>
              <span className="text-3xl sm:text-4xl font-extrabold text-accent font-mono">R$ 77,90</span>
            </div>
            <div className="h-px sm:h-10 w-16 sm:w-px bg-border" />
            <div className="text-center sm:text-left">
              <div className="text-xs text-muted-foreground">Acesso</div>
              <div className="text-sm font-bold text-foreground">Vitalício + Atualizações</div>
            </div>
            <div className="h-px sm:h-10 w-16 sm:w-px bg-border" />
            <div className="text-center sm:text-left">
              <div className="text-xs text-muted-foreground">Garantia</div>
              <div className="text-sm font-bold text-accent">7 dias grátis</div>
            </div>
          </div>
        </motion.div>

        {/* Lista de produtos inclusos */}
        {PRODUCT_ITEMS && PRODUCT_ITEMS.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-6 sm:mb-8 max-w-2xl mx-auto"
          >
            {PRODUCT_ITEMS.slice(0, 4).map((item, i) => (
              <div key={i} className="bg-card border border-border rounded-xl p-3 text-center text-xs sm:text-sm">
                <div className="text-foreground font-medium leading-tight">{item.title}</div>
                <div className="text-accent font-bold font-mono text-xs mt-1">{item.value}</div>
              </div>
            ))}
          </motion.div>
        )}

        {/* Botão CTA */}
        <motion.a
          href="https://pay.kiwify.com.br/bGcYJms"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-accent hover:bg-accent/90 text-accent-foreground font-extrabold text-base sm:text-lg md:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl cursor-pointer text-center w-full sm:w-auto"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          animate={{
            boxShadow: [
              "0px 0px 0px 0px rgba(104,211,145,0)",
              "0px 0px 32px 8px rgba(104,211,145,0.4)",
              "0px 0px 0px 0px rgba(104,211,145,0)",
            ],
          }}
          transition={{ boxShadow: { repeat: Infinity, duration: 2.0 } }}
        >
          QUERO ACESSO AGORA — R$ 77,90
          <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
        </motion.a>

        <p className="text-xs text-muted-foreground mt-4">
          🔒 Pagamento seguro · Acesso Online · Garantia de 7 dias
        </p>

        <div className="flex items-center justify-center gap-2 text-muted-foreground text-xs mt-4">
          <Timer className="w-3.5 h-3.5 text-destructive" />
          <span>Oferta por tempo limitado. Preço pode ser alterado sem aviso prévio.</span>
        </div>
      </div>
    </section>
  );
}
